import { Component, OnInit, NgZone } from "@angular/core";
import { AngularFireAuth } from "@angular/fire/auth";
declare const chrome: any;

@Component({
  selector: "app-extension-alert-dialog",
  templateUrl: "./extension-alert-dialog.component.html",
  styleUrls: ["./extension-alert-dialog.component.scss"],
})
export class ExtensionAlertDialogComponent implements OnInit {
  isMobile = false;
  hasExtension = false;
  constructor(private zone: NgZone, private auth: AngularFireAuth) {
    if (window.outerWidth < 993) {
      // this.isMobile = true;
      this.hasExtension = true;
    } else {
      this.auth.idToken.subscribe((token) => {
        try {
          chrome.runtime.sendMessage(
            "hfaieeklblendoodjfmgaecekjocnigl",
            {
              token: token,
            },
            (reply) => {
              this.zone.run(() => {
                // <== added
                if (reply) {
                  if (reply.status) {
                    if (reply.status === 200) {
                      this.hasExtension = true;
                      console.log(this.hasExtension);
                    }
                  }
                } else {
                  this.hasExtension = false;
                  console.log(this.hasExtension);
                }
              });
            }
          );
        } catch (err) {
          console.log(err);
          this.hasExtension = false;
        }
      });
    }
  }

  ngOnInit(): void {
    try {
      chrome.runtime.sendMessage(
        "cfkallhgakloidldaeapbfjknejmfmfa",
        { message: "version" },
        (reply) => {
          this.zone.run(() => {
            // <== added
            if (reply) {
              if (reply.version) {
                if (reply.version >= 0) {
                  this.hasExtension = true;
                  console.log(this.hasExtension);
                  console.log("GERE");
                }
              }
            } else {
              this.hasExtension = false;
              console.log(this.hasExtension);
              console.log("HERE");
            }
          });
        }
      );
    } catch (err) {
      console.log(err);
      this.hasExtension = false;
    }
  }
}
